/**
 * Help-center pages the security page links to. The group-mapping article is not published yet, so
 * this points to the Security collection it goes into: replace it with the article's address
 * (`https://help.tinct.ai/articles/<id>`) once it is.
 */
export const HELP_ARTICLES = {
  scimGroupMapping: 'https://help.tinct.ai/collections/7236988-security',
} as const;
